export interface DataType {
  channel: string;
  topic: string;
  data: object;
}

const watchMessageBus = (callback: Function) => {
  if (!window.MessageBus) {
    setTimeout(() => watchMessageBus(callback), 50);
    return;
  }
  if (callback) {
    callback();
  }
};

const waitForMessageBus = () =>
  new Promise<void>(resolve => {
    console.log('Waiting for MessageBus.');
    watchMessageBus(() => {
      console.log('connected.');
      resolve();
    });
  });

const messageBusPromise = waitForMessageBus();

const PostalKitBackend = {
  invoke: {
    publishEvent([data]: [DataType]) {
      messageBusPromise.then(() => {
        window.MessageBus.publish({
          channel: data.channel,
          topic: data.topic,
          data: data.data,
        });
      });
    },
  },
  on: {
    onSubscribe(callback: Function, args: [string, string]) {
      let subscription: any;
      const [topic, channel] = args;

      messageBusPromise.then(() => {
        subscription = window.MessageBus.subscribe({
          channel,
          topic,
          callback: (payload: object) => {
            return callback(payload);
          },
        });
      });

      return () => {
        subscription.unsubscribe();
      };
    },
  },
};

export default PostalKitBackend;
